import React, { useCallback, useState } from "react";
import { Button, TextInputField } from "../../../helpers";
import _ from "lodash";
import Fuse from 'fuse.js';

import "../index.css"


const RateContractSearch = (props) => {
    const {rateContractProducts, products, setProducts, company, requirement} = props
    
    const [productSearch, setProductSearch] = useState('')
    const [selectedProducts, setSelectedProducts] = useState([])

    const fuseRC = useCallback(new Fuse(rateContractProducts, {
        keys: ['productString'],
        includeScore: true,
        threshold: 0.3,
        ignoreLocation: true,
        shouldSort: true, 
        getFn: (obj) => {
            return obj.productString.replace(/\s+/g, '')
        },
    }), [rateContractProducts])

    const handleProductFuzzySearch = useCallback(_.debounce(async function (searchText) {
        let searchResults = fuseRC.search(searchText)
        searchResults = searchResults.slice(0, 200)
        const relatedProducts = searchResults.map(eachProduct => eachProduct.item)
        setSelectedProducts(relatedProducts)
    }, 1000), [])

    const handleProductSearch = (e) => {
        setProductSearch(e.target.value)
        handleProductFuzzySearch(e.target.value)
        /*
        const searchResults = fuseRC.search(e.target.value)
        console.log('ser res', searchResults)

        const relatedProducts = searchResults.map(eachProduct => eachProduct.item)
        console.log('related pro', relatedProducts)
        setSelectedProducts(relatedProducts)
        */
    }

    const handleAddProdcut = (e, id, rateContractProducts, products, setProducts) => {
        const filteredProduct = rateContractProducts.find(eachProduct => eachProduct.rateContractProductId === id)
        const isSec2Product = filteredProduct.companyERPCode ? false : true

        let newProduct = {}
        if(!isSec2Product){
            newProduct = {
                productId: id,
                materialId: filteredProduct.materialId,
                companyERPCode: filteredProduct.companyERPCode,
                productName: filteredProduct.companyProdName,
                variantName: filteredProduct.variantName,
                specification: filteredProduct.companyProdSpec,
                brandId: filteredProduct.brandId,
                categoryId: filteredProduct.categoryId,
                quantity: '',
                materialUOMId: filteredProduct.materialUOMId,
                uomValue: filteredProduct.UOMValue,
                buyerRateContractId: filteredProduct.buyerRateContractId,
                isMappedProduct: true,
                buyerRateContractId: filteredProduct.buyerRateContractId,
                companyERPCodeMapId: filteredProduct.companyERPCodeMapId,
                isTaxExempted: filteredProduct.isTaxExempted
            }
        }else{
            newProduct = {
                productId: id,
                companyERPCode: filteredProduct.companyERPCode,
                materialId: filteredProduct.materialId,
                productName: filteredProduct.companyProdName,
                specification: filteredProduct.companyProdSpec,
                brand: filteredProduct.brandId,
                category: filteredProduct.categoryId,
                quantity: '',
                materialUOMId: filteredProduct.materialUOMId,
                uomValue: filteredProduct.UOMValue,
                buyerRateContractId: filteredProduct.buyerRateContractId,
                isMappedProduct: false,
                buyerRateContractId: filteredProduct.buyerRateContractId,
                companyERPCodeMapId: filteredProduct.companyERPCodeMapId,
                isTaxExempted: filteredProduct.isTaxExempted
            }
        }

        const isProductPresent = products.some(eachProduct => eachProduct.productId === newProduct.productId)
        if(!isProductPresent) setProducts([...products, newProduct])
    }

    const productIds = products.map(eachProduct => eachProduct.productId)

    return(
        <div className='flex flex-column add-rc-product'>
            <div className='flex flex-column col-12 px-0'>
                <label htmlFor="searchProducts" className="text-sm">Search Product / Specification / Material Code / ERP Code</label>
                <TextInputField name="" value={productSearch} labelText="" id="searchProducts" onChange={(e) =>handleProductSearch(e, rateContractProducts)} />
            </div>
            <div className="rc-products-container mb-2">
                {
                    selectedProducts.length === 0 ? <p className="flex justify-content-center text-2xl font-medium" style={{color: '#495057'}}>Please search for products</p> :
                    selectedProducts.map(eachProduct => {
                        let isAddButtonDisabled = false
                        let tooltipMsg = ''
                        if (company.tags?.hasRCTaxExemption){
                            if (requirement.isTaxExempted === "Yes"){
                                if (eachProduct.isTaxExempted === false){
                                    isAddButtonDisabled = true
                                    tooltipMsg = 'Only tax-exempted products can be added.'
                                }
                            }else {
                                if (eachProduct.isTaxExempted){
                                    isAddButtonDisabled = true
                                    tooltipMsg = 'Only Taxable products can be added.'
                                }
                            }
                        }

                        return (
                            <div key={`rateContractProduct-${eachProduct.rateContractProductId}`} className="flex flex-row justify-content-between align-items-center pl-3 product-item">
                                <p>
                                    {eachProduct.materialId} <span className="font-bold">|</span> {eachProduct.companyERPCode && `${eachProduct.companyERPCode}`} {eachProduct.companyERPCode && <span className="font-bold">|</span>} {eachProduct.companyProdName} <span className="font-bold">|</span> {eachProduct.companyProdSpec}{' '}
                                    <span className="font-bold">|</span> <span>Price:</span> {eachProduct.unitPrice} <span className="font-bold">|</span> <span>Lead Time:</span> {`${eachProduct.leadTime} day(s)`}
                                </p>
                                <div className="">
                                    <Button label={productIds?.includes(eachProduct.rateContractProductId) ? "Added" : "Add"} className=" h-2rem mr-2" onClick={(e) => handleAddProdcut(e, eachProduct.rateContractProductId, rateContractProducts, products, setProducts)} disabled={productIds?.includes(eachProduct.rateContractProductId) || isAddButtonDisabled} tooltip={tooltipMsg}/>
                                </div>
                            </div>
                        )
                    }
                    )}
            </div>
        </div>
    )
}

export default RateContractSearch